export const getPartnerNotesFromExcelRow = (
  excelRow: Record<string, unknown>,
  noteColumnKeys: string[] = []
): string[] => {
  const notes: string[] = [];

  noteColumnKeys.forEach((columnKey) => {
    const rawValue = excelRow[columnKey];

    if (rawValue === null || rawValue === undefined) return;

    const text = String(rawValue).trim();

    if (text) {
      notes.push(text);
    }
  });

  return notes;
};
